import axios from 'axios';
import apiClient from './apiClient';
import { getApiErrorMessage } from './apiError';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://167.71.62.249/';

const API_URL_AUTH = BASE_URL + 'auth/';

const register = (email, password) => {
    return axios.post(API_URL_AUTH + 'register/', {
        email,
        password
    });
};

const login = (email, password) => {
    return axios.post(API_URL_AUTH + 'login/', {
        email,
        password
    }).then(response => {
        if (response.data.access) {
            localStorage.setItem('user', JSON.stringify(response.data));
        }
        return response.data;
    })
    .catch(error => {
        // Check for specific error types in the response data
      if (error.response) {
        // The request was made and the server responded with an error status
        const responseData = error.response.data;
        
        if (responseData.error === 'email_not_verified') {
          // Create a custom error with the code property
          const customError = new Error(responseData.message);
          customError.code = 'email_not_verified';
          throw customError;
        } else if (responseData.error === 'account_locked') {
          // Handle account locked scenario
          const customError = new Error(responseData.message);
          customError.code = 'ACCOUNT_LOCKED';
          customError.lockoutSeconds = responseData.lockout_seconds;
          throw customError;
        } else if (responseData.error === 'invalid_credentials') {
          // Handle invalid credentials
          const customError = new Error(responseData.message || 'Invalid credentials');
          customError.code = 'INVALID_CREDENTIALS';
          throw customError;
        }
      }
      
      // For any other errors
        throw error;
      });
};

const logout = () => {
    localStorage.removeItem('user');
};

const getCurrentUser = () => {
    return JSON.parse(localStorage.getItem('user'));
};

const getUserProfile = () => {
    return apiClient.get(API_URL_AUTH + 'user/');
};

const updateUserProfile = (data) => {
    return apiClient.put(API_URL_AUTH + 'user/', data);
};

const deleteUserProfile = async (password) => {
    try {
      const response = await apiClient.delete(API_URL_AUTH + 'user/', {
        data: {
          password: password
        }
      });
      return response;
    } catch (error) {
      throw error;
    }
};

const changePassword = (currentPassword, newPassword) => {
    return apiClient.post(API_URL_AUTH + 'change-password/',
        { old_password: currentPassword, new_password: newPassword }
    );
};


const requestPasswordReset = (email) => {
  return axios.post(API_URL_AUTH + 'password-reset/request/', { email })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      // We still want to handle this gracefully even if the email doesn't exist
      // to prevent email enumeration attacks
      throw new Error(getApiErrorMessage(error, 'An error occurred while requesting password reset'));
    });
};

const confirmPasswordReset = (token, newPassword, confirmPassword) => {
  return axios.post(API_URL_AUTH + 'password-reset/confirm/', {
    token,
    new_password: newPassword,
    confirm_password: confirmPassword
  })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      throw new Error(getApiErrorMessage(error, 'An error occurred while resetting your password'));
    });
};

// For a user whose login failed with email_not_verified: the server checks the
// credentials like login does and answers every case with a user-facing `detail`.
const resendVerification = (email, password) => {
    return axios.post(API_URL_AUTH + 'resend-verification/', { email, password });
};

export default {
    register,
    login,
    logout,
    getCurrentUser,
    getUserProfile,
    updateUserProfile,
    deleteUserProfile,
    changePassword,
    requestPasswordReset,
    confirmPasswordReset,
    resendVerification
};
